import { render, staticRenderFns } from "./Mornitor.version.2.vue?vue&type=template&id=4dd11331&"
import script from "./Mornitor.version.2.vue?vue&type=script&lang=js&"
export * from "./Mornitor.version.2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports